module.exports = __webpack_public_path__ + "static/img/5187_phase_function_Paper_PointsHejduk_Prediction.e26ddd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5187_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Ns/9
// module chunks = 0